<template>
	<div class="choose-firm">
		<div class="white-wrap">
			<div class="close" @click="closeChooseFirmClick"></div>
			<div class="back" @click="closeChooseFirmClick"></div>
			<div class="text-title">请选择设备厂商</div>
			<!-- <div class="text1">点击厂商查看设备绑定教程</div> -->
			<div class="firm-item" @click="showGuideClick(3)">
				<div class="firm-icon"><div class="firm-icon2"></div></div>
				<div class="firm-text">群晖</div>
				<div class="firm-icon3"></div>
				<div class="firm-text2">Synology</div>
			</div>
			<div class="firm-item firm-item2" @click="showGuideClick(4)">
				<div class="firm-icon"><div class="firm-icon2"></div></div>
				<div class="firm-text">威联通</div>
				<div class="firm-icon3"></div>
				<div class="firm-text2">QNAP</div>
			</div>
			<div class="firm-item firm-item3" @click="showGuideClick(5)">
				<div class="firm-icon"><div class="firm-icon2"></div></div>
				<div class="firm-text">铁威马</div>
				<div class="firm-icon3"></div>
				<div class="firm-text2">TerraMaster</div>
			</div>
			<div class="firm-item firm-item4" @click="showGuideClick(6)">
				<div class="firm-icon"><div class="firm-icon2"></div></div>
				<div class="firm-text">联想</div>
				<div class="firm-icon3"></div>
				<div class="firm-text2">Lenovo</div>
			</div>
			<div class="firm-item firm-item5" @click="showGuideClick(7)">
				<div class="firm-icon"><div class="firm-icon2"></div></div>
				<div class="firm-text">海康威视</div>
				<div class="firm-icon3"></div>
				<div class="firm-text2">HIKVISION</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "ChooseFirm",
	methods: {
		closeChooseFirmClick: function () {
			let _that = this;
			_that.$store.state.isShowDownload = 1;
		},
		showGuideClick: function (data) {
			let _that = this;
			_that.$store.state.isShowDownload = data;
		},
	},
};
</script>

<style lang="less" scoped>
.choose-firm {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.1);
	.white-wrap {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		width: 680px;
		height: 280px;
		background-color: #ffffff;
		box-shadow: 0px 4px 24px rgba(85, 97, 117, 0.4);
		border-radius: 8px;
		text-align: center;
		.close {
			position: absolute;
			top: 16px;
			right: 16px;
			width: 30px;
			height: 30px;
			background-image: url("../../assets/remote/help8.svg");
			background-repeat: no-repeat;
			background-size: 100% 100%;
			cursor: pointer;
		}
		.back {
			position: absolute;
			top: 16px;
			left: 16px;
			width: 30px;
			height: 30px;
			background-image: url("../../assets/remote/help9.svg");
			background-repeat: no-repeat;
			background-size: 100% 100%;
			cursor: pointer;
		}
		.text-title {
			margin-top: 24px;
			font-weight: 500;
			font-size: 18px;
			line-height: 25px;
			text-align: center;
			color: #1f1f1f;
		}
		.text1 {
			margin-top: 48px;
			font-size: 16px;
			line-height: 22px;
			text-align: center;
			color: #666666;
		}
		.firm-item {
			display: inline-block;
			margin-top: 45px;
			vertical-align: top;
			width: 100px;
			height: 122px;
			box-sizing: border-box;
			border: 1px solid transparent;
			border-radius: 4px;
			cursor: pointer;
			background-color: #f3f9ff;
			border: 1px solid #ffffff;
			.firm-icon {
				position: relative;
				width: 98px;
				height: 48px;
				// background: #f3f9ff;
				// border: 1px solid rgba(22, 59, 122, 0.02);
				border-radius: 4px;
				box-sizing: border-box;
				.firm-icon2 {
					position: absolute;
					left: 50%;
					top: 50%;
					transform: translate(-50%, -50%);
					width: 66px;
					height: 17px;
					background-image: url("../../assets/remote/download1.png");
					background-repeat: no-repeat;
					background-size: 100% 100%;
				}
			}
			.firm-text {
				margin-top: 12px;
				font-weight: 600;
				font-size: 16px;
				line-height: 22px;
				text-align: center;
				color: #666666;
			}
			.firm-icon3 {
				margin: 0 auto;
				margin-top: 4px;
				width: 16px;
				height: 2px;
				background-color: #999999;
				border-radius: 1px;
			}
			.firm-text2 {
				margin-top: 4px;
				font-size: 14px;
				line-height: 20px;
				text-align: center;
				color: #999999;
			}
		}
		.firm-item:hover {
			// padding-top: 2px;
			border: 1px solid rgba(22, 59, 122, 0.6);
			box-shadow: 0px 4px 6px rgba(108, 121, 141, 0.2);
			background-color: #f3f9ff;
			.firm-icon {
				border: 1px solid transparent;
				background-color: #f3f9ff;
			}
			.firm-text {
				color: #163b7a;
			}
			.firm-icon3 {
				background-color: #163b7a;
			}
		}
		.firm-item2 {
			margin-left: 12px;
			.firm-icon {
				.firm-icon2 {
					width: 64px;
					height: 10px;
					background-image: url("../../assets/remote/download18.png");
				}
			}
		}
		.firm-item3 {
			margin-left: 12px;
			.firm-icon {
				.firm-icon2 {
					width: 64px;
					height: 30px;
					background-image: url("../../assets/remote/download19.png");
				}
			}
		}
		.firm-item4 {
			margin-left: 12px;
			.firm-icon {
				.firm-icon2 {
					width: 67px;
					height: 13px;
					background-image: url("../../assets/remote/download20.png");
				}
			}
		}
		.firm-item5 {
			margin-left: 12px;
			.firm-icon {
				.firm-icon2 {
					width: 68px;
					height: 9px;
					background-image: url("../../assets/remote/download23.png");
				}
			}
		}
	}
}
</style>